import React from 'react';
import { motion } from 'framer-motion';
import AdsCart from '../../../ads/modules/AdsCart';
import { timeAgo } from '../../../../../utiels/functions/persianFormat';

export default function Fcard({ allFavorites = [] }) {
    console.log(allFavorites);

    return (
        <div className="grid w-full gap-6 grid-cols-1 pb-5 max-h-full overflow-y-auto sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
            {allFavorites.map((ad, index) => {
                const id = ad?._id || ad?.id || index;
                const image = ad?.image?.path || (Array.isArray(ad?.image) ? (ad.image[0]?.path || ad.image) : ad?.image) || "";
                const title =  ad?.title || 'بدون عنوان';
                const description = ad?.description || '';
                const price = ad?.price || 'تماس بگیرید';
                const dealType = ad?.type || ad?.dealType || 'sales';
                const postedHoursAgo = timeAgo(ad?.createdAt);
                const isSaved = ad?.isSaved || true;

                return (
                    <motion.div
                        key={id}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.06 }}
                        className="w-full"
                    >
                        <AdsCart
                            id={id}
                            image={image}
                            title={title}
                            description={description}
                            price={price}
                            dealType={dealType}
                            postedHoursAgo={postedHoursAgo}
                            index={index}
                            isSaved={isSaved}
                        />
                    </motion.div>
                );
            })}
        </div>
    );
}


